import React, { createContext, Dispatch, ReactNode, Reducer, useReducer } from 'react';
import { doLogin, doGetCustomerInfo } from './Login.api';
import { doLogout } from './Header.api';

export enum ActionType {
  LOGIN = '',
  SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED',
  GET_CUSTOMER_INFO = 'GET_CUSTOMER_INFO',
  SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO',
  RESET = 'RESET',
  LOGOUT = 'LOGOUT',
  SET_REPORT_INFO = 'SET_REPORT_INFO',
  SET_INDIVIDUAL_SITE_PAGE_INFO = 'SET_INDIVIDUAL_SITE_PAGE_INFO',
  SET_GROUP_REPORT_INFO = 'SET_GROUP_REPORT_INFO',
  SET_ERROR = 'SET_ERROR',
  RESET_ERROR = 'RESET_ERROR',
}

interface Action {
  type: ActionType;
  data: any;
}

interface Store {
  state: any;
  dispatch: Dispatch<Action>;
}

const initialState: Store = {
  state: {},
  dispatch: (action) => {},
};

const StoreContext = createContext<Store>(initialState);

const dispatchMiddleware = (dispatch: Dispatch<Action>) => {
  return (action: Action) => {
    switch (action.type) {
      case ActionType.LOGIN:
        doLogin(action.data).then((value) => {
          if (value && value.status===200) {
            return dispatch({ type: ActionType.SET_IS_AUTHENTICATED, data: true });
          }

          return dispatch({ type: ActionType.SET_ERROR, data: value });
          
        }).catch(err => {
          dispatch({ type: ActionType.SET_ERROR, data: err });
        });
        break;
      case ActionType.GET_CUSTOMER_INFO:
        doGetCustomerInfo().then((value) => {
          if (value && !value.error) {
            return dispatch({ type: ActionType.SET_CUSTOMER_INFO, data: value });
          }

          return dispatch({ type: ActionType.SET_ERROR, data: value });
        }).catch(err => {
          dispatch({ type: ActionType.SET_ERROR, data: err });
        });
        break;
      case ActionType.LOGOUT:
        doLogout().then((value) => {
          if (value && value.status===204) {
            return dispatch({ type: ActionType.RESET, data: value });
          }

          return dispatch({ type: ActionType.SET_ERROR, data: value });
        }).catch(err => {
          dispatch({ type: ActionType.SET_ERROR, data: err });
        });
        break;
      default:
        return dispatch(action);
    }
  };
};

const reducer: Reducer<Store, Action> = (state, action) => {
  switch (action.type) {
    case ActionType.SET_IS_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.data,
      };
    case ActionType.SET_CUSTOMER_INFO:
      return {
        ...state,
        customerInfo: action.data,
      };
    case ActionType.SET_REPORT_INFO:
      return {
        ...state,
        reportInfo: action.data,
      };
    case ActionType.SET_GROUP_REPORT_INFO:
      return {
        ...state,
        groupReportInfo: action.data,
      };
    case ActionType.SET_INDIVIDUAL_SITE_PAGE_INFO:
      return {
        ...state,
        individualSiteInfo: action.data,
      };
    case ActionType.SET_ERROR:
      return {
        ...state,
        error: action.data,
      };
    case ActionType.RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    case ActionType.RESET:
      return initialState;
    default:
      throw new Error();
  }
};

const StateProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StoreContext.Provider value={{ state, dispatch: dispatchMiddleware(dispatch) }}>
      {children}
    </StoreContext.Provider>
  );
};

export { StoreContext, StateProvider };
